
export const Strings = {

  loading: "Loading...",
  errorFetching: "Error fetching...",

  availableBalance: "Sendable Balance",
  availableBalanceTooltip: "Your sendable balance is the maximum amount you can send or sell. It will increase over the first 90 days of holding as it is your total balance minus any penalties that would be applied if you were to send or sell.",
  totalBalance: "Total Balance" ,
  totalBalanceTooltip: "Your total balance reflects the number of tokens you hold. Any transactions, whether sending or selling, will decrease the total balance by both the transaction amount and any penalties." ,
  daysHeld: "Days Held" ,
  daysHeldTooltip: "This is how many days you've been holding. Every time you buy tokens or claim rewards this number is reset to zero." ,
  penaltyPercent: "Penalty Percent",
  penaltyPercentTooltip: "Penalty percentage is calculated with the following formula: ((90 - DAYS_HELD) * 50) / 90",
  totalBurned: "Total Burned Tokens",
  totalBurnedTooltip: "This represents the total number of tokens that have been burned by all users paying penalties.",
  charityBalance: "Charity Balance",
  charityBalanceTooltip: "Tokens in charity wallet. Does not include tokens in the liquidity pool owned by the charity address.",

  claimableRewards: "Claimable Rewards",
  claimableRewardsTooltip: "Tokens you can claim from the rewards pool based on your ownership of eligible supply.",
  holdingsEligibleForRewards: "Your Tokens Eligible for Rewards",
  holdingsEligibleForRewardsTooltip: "Number of tokens you've purchased since the last time you claimed rewards (if ever).",
  supplyEligibleForRewards: "Eligible Circulating Supply",
  supplyEligibleForRewardsTooltip: "The total number of tokens that have been purchased by all users, which never been used to claim rewards.",
  ownershipOfEligibleSupply: "Your Ownership of Eligible Supply",
  ownershipOfEligibleSupplyTooltip: "Your percentage ownership of the circulating tokens that are eligible for rewards.",
  rewardsPool: "Tokens in Rewards Pool",
  rewardsPoolTooltip: "The number of tokens in the rewards pool. The pool is populated by 45% of all penalties paid by holders sending/selling early.",

};
